import { partyTypes, partyRoles, partyStatus } from "@/mocks/partes";

interface PartiesFiltersProps {
  filters: Record<string, string>;
  onChange: (filters: Record<string, string>) => void;
}

export default function PartiesFilters({ filters, onChange }: PartiesFiltersProps) {
  const update = (key: string, value: string) => {
    onChange({ ...filters, [key]: value });
  };

  return (
    <div className="bg-white border border-background-200/70 rounded-xl p-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-3">
        <div>
          <label className="block text-xs font-medium text-foreground-600 mb-1">Buscar</label>
          <input
            type="text"
            value={filters.search || ""}
            onChange={(e) => update("search", e.target.value)}
            placeholder="Nome, CPF/CNPJ, e-mail..."
            className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 bg-white text-foreground-900 placeholder:text-foreground-400"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-foreground-600 mb-1">Tipo de parte</label>
          <select
            value={filters.type || ""}
            onChange={(e) => update("type", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 bg-white text-foreground-900"
          >
            <option value="">Todos os tipos</option>
            {partyTypes.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-foreground-600 mb-1">Papel principal</label>
          <select
            value={filters.role || ""}
            onChange={(e) => update("role", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 bg-white text-foreground-900"
          >
            <option value="">Todos os papéis</option>
            {partyRoles.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-foreground-600 mb-1">Status</label>
          <select
            value={filters.status || ""}
            onChange={(e) => update("status", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 bg-white text-foreground-900"
          >
            <option value="">Todos</option>
            {partyStatus.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-foreground-600 mb-1">Município/UF</label>
          <input
            type="text"
            value={filters.municipality || ""}
            onChange={(e) => update("municipality", e.target.value)}
            placeholder="Goiânia, GO..."
            className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 bg-white text-foreground-900 placeholder:text-foreground-400"
          />
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mt-3">
        <label className="flex items-center gap-1.5 text-xs text-foreground-600 cursor-pointer">
          <input
            type="checkbox"
            checked={filters.hasDocs === "yes"}
            onChange={(e) => update("hasDocs", e.target.checked ? "yes" : "")}
            className="rounded border-background-300"
          />
          Possui documento
        </label>
        <label className="flex items-center gap-1.5 text-xs text-foreground-600 cursor-pointer">
          <input
            type="checkbox"
            checked={filters.hasLink === "yes"}
            onChange={(e) => update("hasLink", e.target.checked ? "yes" : "")}
            className="rounded border-background-300"
          />
          Possui vínculo ativo
        </label>
        <label className="flex items-center gap-1.5 text-xs text-foreground-600 cursor-pointer">
          <input
            type="checkbox"
            checked={filters.isTech === "yes"}
            onChange={(e) => update("isTech", e.target.checked ? "yes" : "")}
            className="rounded border-background-300"
          />
          Responsável técnico
        </label>
        {Object.values(filters).some((v) => v) && (
          <button
            onClick={() => onChange({ search: "", type: "", role: "", status: "", municipality: "", hasDocs: "", hasLink: "", isTech: "" })}
            className="px-3 py-1 text-xs font-medium text-foreground-500 bg-background-50 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            <i className="ri-close-line w-3 h-3 inline-flex items-center justify-center mr-1" />
            Limpar filtros
          </button>
        )}
      </div>
    </div>
  );
}